import { format } from 'date-fns'

export const DATE_FIELD_FORMAT = 'MM/dd/yyyy'

/**
 * DateInput commits a partial edit only on blur, so on Enter its committed date can differ from
 * the text shown. When it does, blur the field to commit or revert it, and report it as stale.
 */
export function blurIfDateFieldStale(form: HTMLFormElement, name: string, date: Date | undefined): boolean {
  const input = form.elements.namedItem(name)
  if (!(input instanceof HTMLInputElement) || !date || input.value === format(date, DATE_FIELD_FORMAT))
    return false
  input.blur()
  return true
}
